require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-laravel-dynamic-navigation-package.json") })
        }
      }, "path---post-laravel-dynamic-navigation-package");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-laravel-dynamic-navigation-package!./.cache/json/post-laravel-dynamic-navigation-package.json
// module id = 336
// module chunks = 231608221292675